module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"7":"View up until one week ago","31":"View up until one month ago","92":"View up until one quarter ago","365":"View up until one year ago"},"nl":{"7":"Bekijk tot een week terug","31":"Bekijk tot een maand terug","92":"Bekijk tot een kwartaal terug","365":"Bekijk tot een jaar terug"}}')
  delete Component.options._Ctor
}
